import axios from 'axios'

const host = "https://acs.accelery.de/"

export default () => {
    return axios.create({
      baseURL: host
    })
  }
